//
//
//
//
//
//
//
//
//
//
//

export default {
  methods: {
    onSelect(item) {
      const {tag, disabled} = item
      if (!disabled) {
        this.$emit('change', tag)
      }
    }
  },
  props: {
    tags: Array,
    status: {
      type: String
    }
  }
}
